import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Button from '../../components/ui/Button';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiDollarSign, FiTruck, FiShield } = FiIcons;

const Distribution = () => {
  const [formSubmitted, setFormSubmitted] = useState(false);

  const cards = [
    { icon: FiDollarSign, title: 'Available formats', desc: '100% Ube Powder — 100 g retail pouch and 20 kg (44 lbs) bulk bag.' },
    { icon: FiTruck, title: 'SoCal logistics', desc: 'Fulfilled from Southern California, minutes from the Port of Los Angeles. Fast regional delivery, reliable lead times.' },
    { icon: FiShield, title: 'Full traceability', desc: 'Lot-coded production from farm to pouch; COAs available per lot.' }
  ];

  return (
    <div className="bg-white min-h-screen font-sans">
      <section className="bg-sand py-24 border-b border-sand-dark/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <h1 className="font-serif text-5xl md:text-6xl text-gray-900 mb-6">Put real ube on more shelves.</h1>
            <p className="text-gray-700 text-lg md:text-xl mb-10 leading-relaxed">
              UBEA is Philippine ube from family farms — grown and dried in the Philippines, and shipped from Manila through the Port of Los Angeles, California. We partner with specialty food distributors and regional grocery buyers who want the ube category done right.
            </p>
            <Button to="/wholesale" size="lg">Trade pricing on request</Button>
          </div>
        </div>
      </section>
      <section className="py-24 bg-sand-light">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="font-serif text-3xl text-center text-gray-900 mb-16">What you get as a UBEA distribution partner</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {cards.map((card) => (
              <div key={card.title} className="bg-white p-8 rounded-3xl border border-sand shadow-sm">
                <div className="w-12 h-12 bg-ube-dark text-white rounded-full flex items-center justify-center mb-6"><SafeIcon icon={card.icon} className="w-6 h-6" /></div>
                <h3 className="font-serif text-xl text-gray-900 mb-3">{card.title}</h3>
                <p className="text-gray-600 text-sm leading-relaxed">{card.desc}</p>
              </div>
            ))}
          </div>
          {formSubmitted && <p className="text-center mt-8 text-ube">Thanks for your inquiry.</p>}
          <div className="text-center mt-8">
            <Link to="/wholesale" className="text-ube font-bold hover:underline">Request trade pricing</Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Distribution;